var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEstablished = function SvgEstablished(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V20H5.78876V16.1165H8.21124V19.9676H14V0H0ZM4.18427 13.7217H2.32809V11.2298H4.18427V13.7217ZM4.18427 9.32039H2.32809V6.79612H4.18427V9.32039ZM4.18427 4.88673H2.32809V2.39482H4.18427V4.88673ZM7.92809 13.7217H6.07191V11.2298H7.92809V13.7217ZM7.92809 9.32039H6.07191V6.79612H7.92809V9.32039ZM7.92809 4.88673H6.07191V2.39482H7.92809V4.88673ZM11.6719 13.7217H9.81573V11.2298H11.6719V13.7217ZM11.6719 9.32039H9.81573V6.79612H11.6719V9.32039ZM11.6719 4.88673H9.81573V2.39482H11.6719V4.88673Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEstablished, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/established.dfa02dbc.svg";
export { ForwardRef as ReactComponent };